export function highlightMatch(search, msg, highlightClass) {

  let highlightedString

  if (!search.length) {

    highlightedString = ''

  } else {

    function parsedSearch () {
      return search.trim().replace(/ +/g, '|');
    }
    function parsedMsg() {
      return msg && msg.split(
        new RegExp(parsedSearch() , 'gi'));
    }
    const regex = new RegExp(parsedSearch(), 'gi');
    const pm = parsedMsg();
    const found = msg.match(regex);
    const result = []
    
    function recomposeString () {
      if (!found) return
      let i, l = Math.min(pm.length, found.length);
      for (i = 0; i < l; i++) {
          result.push(pm[i], `<span class="${highlightClass}">${found[i]}</span>`);
      }
      result.push(...pm.slice(l), ...found.slice(l));
      highlightedString = result.join("")
    }
    
    recomposeString();

  }

  return highlightedString
}
